import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';

import loadable from '@loadable/component';
import { reactiveTemplateConfigSelector } from 'common/selectors/theme';
const ProductSummaryVariant = loadable(props =>
  import(`common/blocks/product/detail/summary/${props.blockVariant}`)
);

class ProductSummary extends PureComponent {
  render() {
    const {
      blockVariant,
      data,
      isLocked = false,
      scrollToDescription = null,
      t
    } = this.props;
    if (!data) {
      return null;
    }
    return (
      <ProductSummaryVariant
        blockVariant={blockVariant}
        isLocked={isLocked}
        scrollToDescription={scrollToDescription}
        t={t}
        {...data}
      />
    );
  }
}

const makeMapStateToProps = () => {
  const reactiveTemplateConfig = reactiveTemplateConfigSelector(
    'ProductSummaryVariant'
  );
  return (state, props) => {
    return {
      blockVariant: reactiveTemplateConfig(state, props)
    };
  };
};

const ProductSummaryConnected = connect(makeMapStateToProps)(ProductSummary);

export default withTranslation()(ProductSummaryConnected);
